import { createClient, type Session } from '@supabase/supabase-js';
import { signal } from '@preact/signals';

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'tend.auth',
    },
  }
);

/** null = signed out, undefined = still restoring */
export const session = signal<Session | null | undefined>(undefined);

supabase.auth.getSession().then(({ data }) => {
  session.value = data.session;
});
supabase.auth.onAuthStateChange((_event, s) => {
  session.value = s;
});

export async function signIn(email: string, password: string): Promise<string | null> {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  return error ? error.message : null;
}
